import React, { useEffect, useState } from 'react';
import CreateManufactureUnit from './create';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Button,
  Drawer,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import { Pagination } from '../../../components';
import { ReactComponent as SearchIcon } from '../../../assets/images/Search.svg';
import ActionButtons from '../../../components/actionbutton';
import Filter from '../../../assets/images/Filter.svg';
import FilterDrawer from './filterDrawer';
import { closeBlackIcon } from '../../../assets/images';
import { useHook as manufactureUnitHook } from './useHook';
import { useDispatch, useSelector } from 'react-redux';
import useDebounce from '../../../components/Debounce';
import { setEquipmentDetailsAction } from '../../../stores/actionTypes/equipmentsActions';
import { Popup, Unauthorized } from '../../../components/index';
import { ErrorMessage } from '../../../permissionErrorMessage/PermissionMessage';
import { useHook as EquipmentsDashboard } from '../hardware/equipments/useHook';
interface Props {
  pagePermissionIDs: unknown;
}
const ManufactureUnit: React.FC<Props> = ({ pagePermissionIDs }) => {
  const canCreateUnit =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('units::create');
  const canDeletePermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('units::delete');
  const canlistPermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('units::list');

  const canUpdatePermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('units::update');

  const canEquipmentlistPermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('equipments::list');

  const canGetEquipment =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('equipments::get');

  const canCategorylistPermission =
    Array.isArray(pagePermissionIDs) &&
    pagePermissionIDs.includes('categories::list');

  const requiredAccess = (
    <section className="required_access_section">
      <p>you require below access:</p>
      <ul>
        <li>{ErrorMessage['units::list'] || ''}</li>
        <li>{ErrorMessage['categories::list'] || ''}</li>
      </ul>
    </section>
  );

  const createRequiredAccess = (
    <section className="required_access_section">
      <p>you require below access:</p>
      <ul>
        <li>{ErrorMessage['units::create'] || ''}</li>
        <li>{ErrorMessage['equipments::list'] || ''}</li>
        <li>{ErrorMessage['equipments::get'] || ''}</li>
      </ul>
    </section>
  );

  const navigate = useNavigate();
  const [activeCreate, setActiveCreate] = useState(false);
  const { allCategory } = useSelector((state: any) => state.equipments);
  const { fetchUnitList, handleDeleteUnit } = manufactureUnitHook();
  const { fetchGetListCategory, fetchDealerGetListCategory } =
    EquipmentsDashboard();
  const location = useLocation();
  const pathname = location.pathname;
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filterDrawerOpen, setFliterDrawerOpen] = useState(false);
  const [filterData, setFilterData] = useState<string[]>([]);
  const [equipmentFilter, setEquipmentFilter] = useState<string[]>([]);
  const [serialNumber, setSerialNumber] = useState<string[]>([]);
  const [categoryFilter, setCategoryFilter] = useState<string[]>([]);
  const [subcategoryFilter, setSubCategoryFilter] = useState<string[]>([]);
  const [search, setSearch] = useState<string>('');
  const [deletePopup, setDeletePopup] = useState(false);
  const [deleteId, setDeleteId] = useState<string | number>('');
  const debouncedSearch = useDebounce(search, 1000);
  const { unitList } = useSelector((state: any) => state.manufactureUnit);
  const dispatch = useDispatch();
  const [seeMoreIndex, setSeeMoreIndex] = useState<number>(2);
  const [filterDrawerData, setFilterDrawerData] = useState<any>(null);

  useEffect(() => {
    if (!(allCategory?.length > 0)) {
      fetchGetListCategory({});
    }
  }, []);

  const handleDelete = async () => {
    await handleDeleteUnit({ unitID: deleteId });
    handleGetUnit(currentPage, rowsPerPage, search);
    setDeleteId('');
    setDeletePopup(false);
  };
  const handleCloseDelete = () => {
    setDeleteId('');
    setDeletePopup(false);
  };

  useEffect(() => {
    if (debouncedSearch) {
      handleGetUnit(1, rowsPerPage, search);
      setCurrentPage(1);
    }
  }, [debouncedSearch]);

  useEffect(() => {
    handleGetUnit(1, rowsPerPage, search);
    setSeeMoreIndex(filterData?.length);
    setFilterDrawerData({
      equipment: equipmentFilter.length > 0 ? equipmentFilter : [],
      serialNumber: serialNumber.length > 0 ? serialNumber : [],
      category: categoryFilter.length > 0 ? categoryFilter : [],
      subCategory: subcategoryFilter.length > 0 ? subcategoryFilter : [],
    });
  }, [filterData, canlistPermission]);

  const handleGetUnit = async (
    pagenumber?: number,
    row_perpage?: number,
    search: unknown = '',
    filters?: any,
    sort: { orderBy: string; order: number } = {
      orderBy: 'createdAt',
      order: -1,
    },
  ) => {
    const payload = {
      sort: sort,
      search: search,
      filters: {
        equipment: equipmentFilter.length > 0 ? equipmentFilter : null,
        serialNumber: serialNumber.length > 0 ? serialNumber : null,
        category: categoryFilter.length > 0 ? categoryFilter : null,
        subCategory: subcategoryFilter.length > 0 ? subcategoryFilter : null,
      },
      limit: row_perpage ? row_perpage : rowsPerPage,
      offset: pagenumber
        ? (pagenumber - 1) * rowsPerPage
        : (currentPage - 1) * rowsPerPage,
    };
    if (canlistPermission && canCategorylistPermission) {
      await fetchUnitList(payload).then((res: any) => {
        const totalPage = res?.count
          ? Math.ceil(res?.count / (row_perpage ? row_perpage : rowsPerPage))
          : 1;
        setTotalPages(totalPage);
      });
    }
  };

  //handle remove filter
  const handleRemoveFilter = (filterName: string) => {
    if (equipmentFilter.includes(filterName)) {
      const removeData = equipmentFilter?.filter((data) => data !== filterName);
      setEquipmentFilter(removeData);

      //rmove filterData
      const removeFilterData = filterData?.filter(
        (data) => data !== filterName,
      );
      setFilterData(removeFilterData);
    } else if (serialNumber.includes(filterName)) {
      const removeData = serialNumber?.filter((data) => data !== filterName);
      setSerialNumber(removeData);

      //rmove filterData
      const removeFilterData = filterData?.filter(
        (data) => data !== filterName,
      );
      setFilterData(removeFilterData);
    } else if (subcategoryFilter.includes(filterName)) {
      const removeData = subcategoryFilter?.filter(
        (data) => data !== filterName,
      );
      setSubCategoryFilter(removeData);

      //rmove filterData
      const removeFilterData = filterData?.filter(
        (data) => data !== filterName,
      );
      setFilterData(removeFilterData);
    } else if (categoryFilter.includes(filterName)) {
      const removeData = categoryFilter.filter((data) => data !== filterName);
      setCategoryFilter(removeData);

      // Find the subcategories to remove based on the category name
      const removedSubcategories =
        allCategory?.find(
          (category: { categoryName: string }) =>
            category.categoryName === filterName,
        )?.subCategories || [];

      // Remove subcategories from subcategoryFilter
      const removeSubCategoryData = subcategoryFilter.filter(
        (item) => !removedSubcategories.includes(item),
      );
      setSubCategoryFilter(removeSubCategoryData);

      // Remove from filterData (both category and subcategory)
      const removeFilterData = filterData.filter(
        (item) => !removedSubcategories.includes(item) && item !== filterName,
      );
      setFilterData(removeFilterData);
    }
    // const removeData = filterData?.filter((data) => data !== filterName);
    // setFilterData(removeData);
    setCurrentPage(1);
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    handleGetUnit(page, rowsPerPage, search);
  };
  const handleRowsPerPageChange = (value: number) => {
    handleGetUnit(1, value, search);
    setRowsPerPage(value);
    setCurrentPage(1);
  };

  useEffect(() => {
    pathname === '/manufacture/production/create'
      ? setActiveCreate(true)
      : (setActiveCreate(false),
        dispatch(setEquipmentDetailsAction({})),
        setFilterData([]));
  }, [pathname]);

  const handlePageContentChange = (page: string) => {
    if (pathname !== page) {
      navigate(page);
      setFilterData([]);
      setEquipmentFilter([]);
      setSerialNumber([]);
      setCategoryFilter([]);
      setSubCategoryFilter([]);
      setCurrentPage(1);
      setSearch('');
    }
  };
  const fliterOpenDrawer = () => {
    setFliterDrawerOpen(true);
  };

  const fliterCloseDrawer = () => {
    setFliterDrawerOpen(false);
  };
  const filterSubmit = (data: any) => {
    if (data !== undefined && data !== null) {
      const filterData = [
        ...data.equipment,
        ...data.serialNumber,
        ...data.category,
        ...data.subCategory,
      ];
      setFilterData(filterData);
      setEquipmentFilter(data.equipment);
      setSerialNumber(data.serialNumber);
      setCategoryFilter(data.category);
      setSubCategoryFilter(data.subCategory);
      console.log(filterData, 'filterDatafilterData');
    }
    setFliterDrawerOpen(false);
  };

  const handleSearchChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const search = event.target.value;
    // Allow only letters, numbers, and spaces
    const regex = /^[a-zA-Z0-9 ]*$/;
    if (regex.test(search)) {
      setSearch(search);

      if (!search) {
        handleGetUnit(currentPage, rowsPerPage, search);
      } else {
        setCurrentPage(1);
      }
    }
  };

  function formatDate(isoDate: string | Date) {
    const months = [
      'JAN',
      'FEB',
      'MAR',
      'APR',
      'MAY',
      'JUN',
      'JUL',
      'AUG',
      'SEP',
      'OCT',
      'NOV',
      'DEC',
    ];

    const date = new Date(isoDate);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  }

  function formatTime(isoDate: string | Date): string {
    const date = new Date(isoDate);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${hours}:${minutes}:${seconds}`;
  }

  return (
    <>
      {!canlistPermission || !canCategorylistPermission ? (
        <Unauthorized requiredAccess={requiredAccess} />
      ) : (
        <>
          {deletePopup && (
            <Popup
              open={deletePopup}
              handleClose={handleCloseDelete}
              handleDelete={handleDelete}
              page="Unit"
            />
          )}

          <Drawer
            open={filterDrawerOpen}
            anchor="right"
            onClose={fliterCloseDrawer}
          >
            <FilterDrawer
              fliterCloseDrawer={fliterCloseDrawer}
              filterSubmit={filterSubmit}
              filterDrawerData={filterDrawerData}
            />
          </Drawer>
          <div className="manufacture_header">
            <div
              className={
                filterData?.length > 0
                  ? ' audilog_update  manufacture_filter-header'
                  : 'audilog_update'
              }
            >
              <Button
                className={activeCreate ? 'activeEdit' : ''}
                onClick={() =>
                  handlePageContentChange('/manufacture/production/create')
                }
              >
                Create
              </Button>
              <Button
                className={!activeCreate ? 'activeEdit' : ''}
                onClick={() =>
                  handlePageContentChange('/manufacture/production')
                }
              >
                List
              </Button>
            </div>
            {!activeCreate && (
              <div className="manufacture_header-search">
                <div className="table-header-btn">
                  <TextField
                    variant="outlined"
                    placeholder="Search"
                    value={search}
                    onChange={handleSearchChange}
                    InputProps={{
                      startAdornment: <SearchIcon />,
                    }}
                    className="search-input"
                  />
                </div>
                <ActionButtons
                  image={Filter}
                  title={'Filter'}
                  action={fliterOpenDrawer}
                  activeData={filterData}
                />
              </div>
            )}
          </div>

          <section className="manufacture_filterlist-data">
            {filterData?.slice(0, seeMoreIndex).map((data, index) => (
              <div key={index} className="filterlist">
                <p>{data}</p>
                <Button onClick={() => handleRemoveFilter(data)}>
                  <img src={closeBlackIcon} alt="Delete Icon" width={13} />
                </Button>
              </div>
            ))}
            {filterData?.length > 2 && seeMoreIndex === 2 && (
              <div className="see_more_data">
                <Button
                  onClick={() => setSeeMoreIndex(filterData?.length)}
                >{`+${filterData?.length - 2} More`}</Button>
              </div>
            )}
            {filterData?.length > 2 && seeMoreIndex !== 2 && (
              <div className="see_more_data">
                <Button onClick={() => setSeeMoreIndex(2)}>show less</Button>
              </div>
            )}
          </section>

          {activeCreate ? (
            !canCreateUnit ||
            !canEquipmentlistPermission ||
            !canGetEquipment ? (
              <Unauthorized requiredAccess={createRequiredAccess} />
            ) : (
              <CreateManufactureUnit />
            )
          ) : (
            <>
              <TableContainer className="controller_table" component={Paper}>
                <Table>
                  <TableHead className="controller_tableheader">
                    <TableRow>
                      <TableCell>Serial Number</TableCell>
                      <TableCell>Equipment Model</TableCell>
                      <TableCell>Equipment Name</TableCell>
                      <TableCell>Manufacture Unit Name</TableCell>
                      <TableCell>Creation date</TableCell>
                      <TableCell className="controller_tableheader_icon"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {unitList?.length === 0 ? (
                      <TableRow>
                        <TableCell colSpan={2}>
                          <Typography variant="body1" align="left">
                            No Data found
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ) : (
                      unitList?.map((equipment: any, index: number) => (
                        <TableRow key={index}>
                          <TableCell>
                            <p className="controller_management_model-data">
                              {equipment?.serialNumber}
                            </p>
                          </TableCell>
                          <TableCell>
                            <p className="controller_management_model-data">
                              {equipment?.equipmentName}
                            </p>
                          </TableCell>
<TableCell>
    <p className="controller_management_model-data">
                              {equipment?.equipmentName}
                            </p>
</TableCell>
                          <TableCell>
                            <p className="controller_management_model-data">
                              {equipment?.unitName || ''}
                            </p>
                          </TableCell>
                          <TableCell>
                            <p className="controller_management_model-data">
                              {
                                formatDate(equipment?.createdAt)
                                //  +
                                //   ' ' +
                                //   formatTime(equipment?.createdAt)
                              }
                            </p>
                          </TableCell>
                          <TableCell>
                            <div className="form-action-btn">
                              {canUpdatePermission && (
                                <Button
                                  className="btn-transparent border-0 img-background-form"
                                  onClick={() =>
                                    navigate(
                                      `/manufacture/production/edit/${equipment?.equipmentModel ? equipment?.equipmentModel : ' '}/${equipment.unitID}`,
                                    )
                                  }
                                >
                                  <i className="edit-icon bi bi-pencil-square bi-lg"></i>
                                </Button>
                              )}

                              {canDeletePermission && (
                                <Button
                                  className="btn-transparent border-0 img-background-form"
                                  onClick={() => {
                                    setDeleteId(equipment.unitID),
                                      setDeletePopup(true);
                                  }}
                                >
                                  <i className="delete-icon bi bi-trash3-fill bi-lg"></i>
                                </Button>
                              )}
                            </div>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <Pagination
                rowsPerPageOptions={[5, 10, 20, 30]}
                currentPage={currentPage}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
                totalPages={totalPages}
              />
            </>
          )}
        </>
      )}
    </>
  );
};

export default ManufactureUnit;
